import axios from 'axios';
import JSEncrypt from 'jsencrypt';

const encrypt = new JSEncrypt();
let publicKey = '';

function getPublicKey(params) {
  if (!publicKey) {
    // return axios.get(`mock/publickey.json`);
    return axios.get(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/publickey`, {
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
      params,
    });
  } else {
    return { data: { publicKey } };
  }
}

export async function encryptText(text, params) {
  const { data } = await getPublicKey(params);

  publicKey = data.publicKey;
  // public key 설정
  encrypt.setPublicKey(publicKey);

  return encrypt.encrypt(text) || '';
}
